import React, {useState} from 'react'
import { ProfileImage } from '../../../components/ProfileImage'
import styles from './ImageSection.scss'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import {imageType} from "../../../utils/Form"
import { AddFile } from 'jbc-front/components/icons'


function BranchImageSectionShow({dispatch, logo, signature, t}) {

    return (
        <div className={styles.imagesection} style={{paddingTop: "20px", justifyContent: "space-evenly"}}>
            <ProfileImage name="logo" label={t('features.Clients.containers.BranchImageSection.branch_logo')}
                          image={imageType(logo)} defaultImage={<AddFile size={256} />} />

            <ProfileImage name="signature" label={t('features.Clients.containers.BranchImageSection.branch_signature')}
                          image={imageType(signature)} defaultImage={<AddFile size={256} />} />
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {
    const idx = ownProps.index
    const signature = state.clients.item.data.clientBranch[idx].branchSignature
    const logo = state.clients.item.data.clientBranch[idx].branchLogo
    return({
        logo: logo,
        signature: signature
    })
}
export default connect(mapStateToProps)(withTranslation()(BranchImageSectionShow))